import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  inputAttentionMessage: {
    color: theme.palette.error.remove,
    marginTop: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
}));

export default useStyles;
